import React from "react";
import { MessageCircle } from "lucide-react";
import { openWhatsApp } from "@/lib/whatsapp";

export default function WhatsAppFloat() {
  return (
    <button
      data-testid="floating-whatsapp-button"
      onClick={() => openWhatsApp()}
      className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-whatsapp text-white shadow-lg shadow-black/20 flex items-center justify-center hover:scale-105 active:scale-95 transition-transform"
      aria-label="Order on WhatsApp"
    >
      <MessageCircle size={26} />
    </button>
  );
}
